module.exports = "/static/assets/c4fedf6d8022763dafa4432c2fe574aa.gif";